import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";

import Header from "../cmponants/Header";
import Hero from "../cmponants/Hero";
import Vision from "../cmponants/Vision";
import MarqueeEffect from "../cmponants/MarqueeEffect";
import DigitalFeature from "../cmponants/DigitalFeature";
import Footer from "../cmponants/Footer";
import ParticlesCanvas from "../cmponants/ParticlesCanvas";

export default function MainPage() {
  const KEY = "theme-preference";
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  const getStored = () => localStorage.getItem(KEY) || "system";

  const [theme, setTheme] = useState(() => getStored());
  const [particlesEnabled, setParticlesEnabled] = useState(true);

  const location = useLocation();

  // Apply theme
  useEffect(() => {
    const effective = theme === "system" ? getSystemTheme() : theme;
    document.documentElement.setAttribute("data-theme", effective);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    const order = ["system", "light", "dark"];
    const next = order[(order.indexOf(theme) + 1) % order.length];
    setTheme(next);
  };

  const toggleParticles = () => setParticlesEnabled((v) => !v);

  // Initialize ScrollSmoother
  useEffect(() => {
    gsap.registerPlugin(ScrollSmoother);
    if (!window.smoother) {
      window.smoother = ScrollSmoother.create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        smooth: 2,
        smoothTouch: false,
      });
    }
  }, []);

  // Scroll to section if coming from Contact page
  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element && window.smoother) {
          window.smoother.scrollTo(element, true, "top top");
        }
        window.history.replaceState({}, document.title); // clear state
      }, 50);
    }
  }, [location]);

  return (
    <div id="smooth-wrapper">
      <div id="smooth-content">

        <Header
          theme={theme}
          toggleTheme={toggleTheme}
          particlesEnabled={particlesEnabled}
          toggleParticles={toggleParticles}
        />

        {particlesEnabled && <ParticlesCanvas enabled={particlesEnabled} />}

        <Hero />

        <div className="page-bg">
          <div id="vision"><Vision /></div>
          <div id="services"><MarqueeEffect /></div>
          <DigitalFeature />
          <Footer />
        </div>

      </div>
    </div>
  );
}
